namespace $.$$ {

	$mol_style_attach( '$shm_projects_catalog_activity_spin', `
		@keyframes shm_projects_catalog_activity_spin {
			to { transform: rotate(360deg); }
		}
		[shm_projects_catalog_project_activity][data-status="busy"] {
			box-sizing: border-box;
			width: .8rem;
			height: .8rem;
			border: 2px solid currentColor;
			border-right-color: transparent;
			border-radius: 50%;
			animation: shm_projects_catalog_activity_spin .8s linear infinite;
		}
	` )
	
	$mol_style_define( $shm_projects_catalog, {
		
		Menu_page: {
			Body_content: { padding: { right: '0.5rem' } },
			flex: {
				basis: '22rem',
				grow: 0,
				shrink: 0,
			},
			width: '22rem',
			minWidth: 0,
		},
		List_head: { minWidth: 0, maxWidth: '100%', Head: { flexWrap: 'wrap' }, Title: { minWidth: 0, whiteSpace: 'normal', flex: { shrink: 1 } } },

		Projects: {
			// Compensate the tree's inherited -0.5rem left margin without moving its text.
			width: $mol_style_func.calc( '100% + 0.5rem' ),
			maxWidth: 'none',
			flex: {
				direction: 'column',
			},
		},

		Catalog_page: {
			flex: { grow: 1, shrink: 1, basis: 0 },
			minWidth: 0,
			width: 0,
		},

		Catalog_scroll: {
			minWidth: 0,
		},

		Catalog_content: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			minWidth: 0,
		},

		Timeline: {
			flex: { direction: 'column' },
			gap: $mol_gap.text,
			minWidth: 0,
			overflowX: 'auto',
		},

		Timeline_title: {
			font: { size: '1.1rem', weight: 'bold' },
		},

		Timeline_days: {
			display: 'grid',
			gridTemplateColumns: 'repeat(14, minmax(8rem, 1fr))',
			gap: $mol_gap.text,
			minWidth: '112rem',
			alignItems: 'start',
		},

		Timeline_day: {
			flex: { direction: 'column' },
			alignSelf: 'start',
			gap: $mol_gap.text,
			minHeight: '6rem',
			border: { width: '1px', style: 'solid', color: $mol_theme.line, radius: $mol_gap.round },
			background: { color: $mol_theme.card },
		},

		Timeline_day_title: {
			padding: $mol_gap.text,
			color: $mol_theme.shade,
			font: { size: '.8rem', weight: 'bold' },
		},

		Timeline_events: {
			flex: { direction: 'column' },
			gap: $mol_gap.text,
		},

		Timeline_event: {
			justifyContent: 'flex-start',
			padding: $mol_gap.text,
			font: { size: '.8rem' },
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
		},

		Timeline_empty: {
			color: $mol_theme.shade,
		},

		Project_table: {
			flex: { direction: 'column' },
			minWidth: '48rem',
		},

		Project_table_head: {
			display: 'grid',
			gridTemplateColumns: 'minmax(14rem, 1.6fr) repeat(3, minmax(7rem, .7fr)) minmax(8rem, .8fr)',
			gap: $mol_gap.text,
			color: $mol_theme.shade,
			font: { size: '.8rem', weight: 'bold' },
		},

		Project_head_title: { padding: $mol_gap.text },
		Project_head_version: { padding: $mol_gap.text },
		Project_head_prerelease: { padding: $mol_gap.text },
		Project_head_release: { padding: $mol_gap.text },
		Project_head_date: { padding: $mol_gap.text },

		Project_rows: {
			flex: { direction: 'column' },
		},

		Project_row: {
			display: 'grid',
			gridTemplateColumns: 'minmax(14rem, 1.6fr) repeat(3, minmax(7rem, .7fr)) minmax(8rem, .8fr)',
			alignItems: 'center',
			gap: $mol_gap.text,
			minWidth: 0,
			border: { top: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},

		Project_row_title: {
			justifyContent: 'flex-start',
			minWidth: 0,
			overflowWrap: 'anywhere',
		},

		Project_row_version: {
			justifyContent: 'flex-start',
		},

		Project_row_prerelease: { padding: $mol_gap.text, color: $mol_theme.current },
		Project_row_release: { padding: $mol_gap.text, color: $mol_theme.shade },
		Project_row_date: { padding: $mol_gap.text, color: $mol_theme.shade },

		Project_link: {
			padding: { right: 0 },
			alignItems: 'center',
			position: 'relative',
			boxSizing: 'border-box',
			width: '100%',
			overflow: 'visible',
		},

		Project_label: {
			flex: { direction: 'column', grow: 1, shrink: 1 },
			minWidth: 0,
		},

		Project_id: {
			font: { size: '.75rem' },
			color: $mol_theme.shade,
			overflowWrap: 'anywhere',
		},

		Project_title_row: {
			width: '100%',
			minWidth: 0,
			overflow: 'hidden',
			gap: '0.375rem',
			align: { items: 'center' },
		},

		Project_title: {
			// Match session titles: marker changes cannot change the row height.
			flex: { basis: 0, grow: 1, shrink: 1 },
			minWidth: 0,
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
		},

		Project_activity: {
			flex: { grow: 0, shrink: 0 },
			width: '0.8rem',
			height: '0.8rem',
			align: { items: 'center' },
			justifyContent: 'center',
			font: { size: '0.65rem' },
			color: $mol_theme.shade,
			':not([data-status])': { display: 'none' },
			'[data-status]': {
				unread: { color: $mol_theme.current },
				'': { display: 'none' },
			},
		},

		New_project_form: {
			flex: {
				direction: 'column',
			},
			gap: $mol_gap.block,
		},

		New_project_actions: {
			gap: $mol_gap.text,
			flex: {
				wrap: 'wrap',
			},
		},
		
	} )
	
}
